/**
 * Configuration du branding multi-domaine
 *
 * @description
 * Ce fichier centralise les configurations de branding pour les 3 marques :
 * - Qualifop (pwa.local.gd) : Version actuelle, mode Full
 * - Syn'APPs Solution (synappssolution.local.gd) : Nouvelle marque, mode Full
 * - Syn'APPs Parcours (synappsparcours.local.gd) : Nouvelle marque, mode Light
 *
 * @author iLabs
 * @date 2024
 */

export const brandingConfig = {
  'synappssolution': {
    name: "Syn'APPs Solution",
    title: "Syn’APPs",
    title_copyright: "®",
    title_light: "Solution",
    tagline: "Piloter et tracer les parcours administratifs et pédagogiques des structures APP, en centre, en alternance et en multi-financement.",
    logoPath: null,
    primaryColor: '#35505B',
    menuBarColor: '#35505B',
    useSvgLogo: true,
    isLightMode: false
  },

  'synappsparcours': {
    name: "Syn'APPs Parcours",
    title: "Syn’APPs",
    title_copyright: "®",
    title_light: "Parcours",
    tagline: "Piloter, tracer et accompagner les parcours pédagogiques des publics en APP, y compris en alternance.",
    logoPath: null,
    primaryColor: '#35505B',
    menuBarColor: '#35505B',
    useSvgLogo: true,
    isLightMode: true
  }
}

export const brandingAliases = {
  // Syn'APPs Solution
  'synappssolution.local.gd': 'synappssolution',
  'www.synapps-solution.fr': 'synappssolution',
  'synapps-solution.fr': 'synappssolution',

  // Syn'APPs Parcours
  'synappsparcours.local.gd': 'synappsparcours',
  'synapps-parcours.fr': 'synappsparcours',
  'www.synapps-parcours.fr': 'synappsparcours'

}


/**
 * Configuration par défaut (fallback)
 * Utilisée si le domaine n'est pas reconnu
 */
export const defaultBrandingKey = 'synappssolution'

/**
 * Récupère la configuration de branding selon le hostname
 *
 * @param {string} hostname - Le hostname actuel (window.location.hostname)
 * @returns {object} Configuration de branding correspondante
 */
export function getBrandingByHostname(hostname) {
  const key = brandingAliases[hostname] || defaultBrandingKey
  return brandingConfig[key]
}
